interface FilterSlidersIconProps {
  size?: number;
  color?: string;
}

const FilterSlidersIcon = ({ size = 22, color = "#1A325D" }: FilterSlidersIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Top bar */}
    <line x1="1" y1="4.5" x2="21" y2="4.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    {/* Top handle */}
    <circle cx="6.5" cy="4.5" r="2.5" fill="white" stroke={color} strokeWidth="1.5" />
    {/* Middle bar */}
    <line x1="1" y1="11" x2="21" y2="11" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    {/* Middle handle */}
    <circle cx="15.5" cy="11" r="2.5" fill="white" stroke={color} strokeWidth="1.5" />
    {/* Bottom bar */}
    <line x1="1" y1="17.5" x2="21" y2="17.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    {/* Bottom handle */}
    <circle cx="9.5" cy="17.5" r="2.5" fill="white" stroke={color} strokeWidth="1.5" />
  </svg>
);

export default FilterSlidersIcon;
